// Order matters: leaflet's UMD dist assigns window.L itself (leaflet #2364);
// the three plugins below read the global L at eval time. This module must be
// imported before ./controllers so window.L exists when geoman's dist evaluates.
import "leaflet";
import "leaflet.heat";
import "leaflet.markercluster";
import "./leaflet_awesome_number_markers";
